<template>
    <div>
        <el-dialog :visible.sync="sta.show">
            <span slot="title">安全巡检设置</span>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label><b>图片上传</b></label><br />
                        <el-radio v-model="imgup" label="1">必须上传</el-radio>
                        <el-radio v-model="imgup" label="0">可选上传</el-radio>
                    </div>
                </div>
            </div>
            <div slot="footer" v-loading="sta.loading">
                <el-button icon="el-icon-close" @click="sta.show = false">取消</el-button>
                <el-button icon="el-icon-check" type="success" @click="submit">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            sta: {
                show: false,
                loading: false
            },
            model: {},
            imgup: '0',
        }
    },
    methods: {
        init() {
            this.sta = { show: true, loading: false }
            let self = this;

            this.sta.loading = true;
            this.whale.remote.getResult({
                url: "/api/School/FX/DictApi/getByName",
                data: { TYPE: "SAFE", NAME: "IMGUP" },
                finally() { self.sta.loading = false; },
                completed: function (its) {
                    if (its.DATA) {
                        self.model = its.DATA;
                        self.imgup = its.DATA.VALUE;
                        console.log('its.DATA.VALUE', its.DATA.VALUE)
                        console.log('its.DATA', its.DATA)
                    } else {
                        self.model = {
                            TYPE: "SAFE",
                            NAME: "IMGUP",
                            VALUE: self.imgup,
                            DESCRIPTION: "安全巡检图片上传设置"
                        }
                        console.log('model', self.model)
                    }
                }
            })
        },
        submit() {
            let self = this;
            self.model.VALUE = self.imgup;
            self.sta.loading = true;
            this.whale.remote.getResult({
                url: "/api/School/FX/DictApi/Save",
                data: self.model,
                finally() { self.sta.loading = false; },
                completed: function () {
                    self.$message.success('设置成功！')
                    self.sta.show = false;
                }
            })
        },
        open() {
            // this.state = false
        }
    },
}
</script>
<style lang="less" scoped></style>